import combine from '../services/combine-service';

const tnms = {
  all: []
};
export default function(state = tnms, action) {
  var payload;
  switch (action.type) {
    case 'tmsheets - tnmReducer':
      return {
        ...state,
        all: action.payload
      };
      break;
    case 'Update > tmsheets':
      return {
        ...state,
        all: combine(state.all, action.payload, 'id', action.deletestatus)
      };
      break;
    case 'Feathers Update > tmsheets':
      return {
        ...state,
        all: combine(state.all, action.payload, 'id', action.deletestatus)
      };
      break;
    default:
      return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/tnm-reducer.js